import { render, staticRenderFns } from "./routeList.vue?vue&type=template&id=213a912d&scoped=true&"
import script from "./routeList.vue?vue&type=script&lang=js&"
export * from "./routeList.vue?vue&type=script&lang=js&"
import style0 from "./routeList.vue?vue&type=style&index=0&id=213a912d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a912d",
  null
  
)

export default component.exports